import React, { useState, useMemo } from 'react';
import { Modal } from '../../components';
import {
    useUpdateMultipleTagItemSkuMutation,
    useGetAllProductsQuery,
} from '../../store';
import Creatable from 'react-select/creatable';
import classNames from 'classnames';
import lodashOrderBy from 'lodash/orderBy';

export const EditSkuModal = (props) => {
    const { show, onClose, projectId, skuItems } = props;
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [updateMultipleTagItemSku] = useUpdateMultipleTagItemSkuMutation();
    const { data: products, isLoading: isProductLoading } =
        useGetAllProductsQuery();

    const productOptions = useMemo(() => {
        if (!products || isProductLoading) return [];
        return lodashOrderBy(
            products.map((prod) => ({
                label: prod.name,
                value: prod.id,
            })),
            ['label'],
            ['asc'],
        );
    }, [products, isProductLoading]);

    const handleSubmit = async () => {
        if (!selectedProductId) return;

        try {
            await updateMultipleTagItemSku({
                id: projectId,
                items: skuItems,
                productId: selectedProductId,
            }).unwrap();
        } catch (err) {
            console.error('Failed to update SKUs:', err);
        }
        onClose();
    };

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="sm:container p-4">
                <h1>Edit SKU for Selected Products</h1>
                <div className="mb-4">
                    <p className="mb-4 text-sm">
                        You are about to change the SKU for {skuItems.length}{' '}
                        selected product{skuItems.length !== 1 ? 's' : ''}.
                    </p>
                    <div className="mb-4">
                        <Creatable
                            classNames={{
                                control: (state) =>
                                    classNames(
                                        'flex items-center w-full !bg-black-5 border border-black-10 !hover:border-black-20 !rounded-none !shadow-none',
                                        state.isFocused && '!border-green-dark',
                                    ),
                                option: (state) =>
                                    classNames(
                                        state.isSelected &&
                                            'bg-green-primary text-white',
                                        'hover:bg-green-primary hover:text-white',
                                    ),
                                menu: () =>
                                    'shadow-swegon2 border border-black-20 !z-50',
                                menuPortal: () => '!z-50',
                            }}
                            menuPortalTarget={document.body}
                            options={productOptions}
                            onChange={(option) =>
                                setSelectedProductId(option?.value || null)
                            }
                            value={
                                productOptions.find(
                                    (opt) => opt.value === selectedProductId,
                                ) || null
                            }
                            placeholder="Select a product..."
                            isLoading={isProductLoading}
                        />
                    </div>
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        type="button"
                        className="swegon-like-button outlined mr-4 !px-4 amber"
                    >
                        Cancel
                    </button>
                    <button
                        className="swegon-like-button contained"
                        onClick={handleSubmit}
                        disabled={!selectedProductId}
                    >
                        Update SKU
                    </button>
                </div>
            </div>
        </Modal>
    );
};
